<input type="checkbox" id="findMatchCase" class="toolbarField" />
<label for="findMatchCase" class="toolbarLabel" data-l10n-id="pdfjs-find-match-case-checkbox-label"> Match case </label>
